export default "__VITE_ASSET__D89E5vVX__"